import { eventChannel } from 'redux-saga';
import { put, takeLatest } from 'redux-saga/effects';
import { API, graphqlOperation } from 'aws-amplify';
import types from './types';
import actions from './actions';
import * as queries from '../../../../graphql/queries';
import * as mutations from '../../../../graphql/mutations';
import * as subscriptions from '../../../../graphql/subscriptions';

function * getEntities () {
  try {
    const entitiesResponse = yield API.graphql(
      graphqlOperation(queries.listEntitys, { limit: 1000 })
    );
    const {
      data: {
        listEntitys: { items }
      }
    } = entitiesResponse;

    yield put(actions.getEntitiesSuccess(items));
    yield put(actions.subscribeEntities());
  } catch (error) {
    yield put(actions.getEntitiesFailure(error));
  }
}

function * createEntity (payload) {
  try {
    const { entity } = payload;
    yield API.graphql(
      graphqlOperation(mutations.createEntity, { input: entity })
    );

    yield put(actions.createEntitySuccess());
  } catch (error) {
    yield put(actions.createEntityFailure(error));
  }
}

function * updateEntity (payload) {
  const { id, entity, version } = payload;
  try {
    yield API.graphql(
      graphqlOperation(mutations.updateEntity, {
        input: { ...entity, id, expectedVersion: version }
      })
    );

    yield put(actions.updateEntitySuccess(id));
  } catch (error) {
    yield put(actions.updateEntityFailure(id, error));
  }
}

function * deleteEntity (payload) {
  const { id, version } = payload;
  try {
    yield API.graphql(
      graphqlOperation(mutations.deleteEntity, {
        input: { id, expectedVersion: version }
      })
    );

    yield put(actions.deleteEntitySuccess(id));
  } catch (error) {
    yield put(actions.deleteEntityFailure(id, error));
  }
}

let putToEntitySubscriptionChannel;
const entitySubscriptionChannel = (() => {
  return eventChannel(emit => {
    putToEntitySubscriptionChannel = (payload) => {
      emit(payload);
    };
    return () => {};
  });
})();

function * subscriptionMessageReceieved (payload) {
  yield put(payload);
}

let activeSubscriptions = [];

function * subscribeEntities () {
  activeSubscriptions.map((subscription) => subscription.unsubscribe());
  const creationSubscription = yield API.graphql(graphqlOperation(subscriptions.onCreateEntity)).subscribe({
    next: async createdEntity => {
      await putToEntitySubscriptionChannel(
        actions.subscriptionEntityCreated(createdEntity)
      );
    }
  });
  const updateSubscription = yield API.graphql(graphqlOperation(subscriptions.onUpdateEntity)).subscribe({
    next: async updatedEntity => {
      await putToEntitySubscriptionChannel(
        actions.subscriptionEntityUpdated(updatedEntity)
      );
    }
  });
  const deletionSubscription = yield API.graphql(graphqlOperation(subscriptions.onDeleteEntity)).subscribe({
    next: async deletedEntity => {
      await putToEntitySubscriptionChannel(
        actions.subscriptionEntityDeleted(deletedEntity)
      );
    }
  });
  activeSubscriptions = [creationSubscription, updateSubscription, deletionSubscription];
}

function unsubscribeEntities () {
  activeSubscriptions.map((subscription) => subscription.unsubscribe());
}

export const adminEntitiesSagas = [
  takeLatest(types.GET_ENTITIES_REQUEST, getEntities),
  takeLatest(types.CREATE_ENTITY_REQUEST, createEntity),
  takeLatest(types.UPDATE_ENTITY_REQUEST, updateEntity),
  takeLatest(types.DELETE_ENTITY_REQUEST, deleteEntity),
  takeLatest(types.SUBSCRIBE_ENTITIES, subscribeEntities),
  takeLatest(types.UNSUBSCRIBE_ENTITIES, unsubscribeEntities),
  takeLatest(entitySubscriptionChannel, subscriptionMessageReceieved)
];
